import { _freeze, } from '../util/data';
import { _routePoint, } from './RoutePoint';
import { _routeLine, } from './RouteLine';
import { _routePanes, } from '../route-service/RoutePanes';
import { _routeLength, } from '../route-service/RouteLength';
import { _ViewMarker, } from '../route-view/route-features';
import { _updateRouteColors, } from '../route-service/route-colors';
import { _markerSettings, } from '../route-view/route-feature-settings';
const _route = (latLngs, $map) => {
    const route = _freeze({
        c: () => pointCount,
        am: () => pointAddingMode,
        p: () => panes,
        len: () => length,
        dm: () => distanceMarkers,
        s: () => startPoint,
        e: () => endPoint,
        sv: () => $startViewMarker,
        ev: () => $endViewMarker,
        inc: () => {
            ++pointCount;
            return route;
        },
        dec: () => {
            --pointCount;
            return route;
        },
        set: (args) => {
            if (args.s) {
                startPoint = args.s;
            }
            if (args.e) {
                endPoint = args.e;
            }
            if (args.am) {
                pointAddingMode = args.am;
            }
            return route;
        },
    }), panes = _routePanes($map), distanceMarkers = [], outerMarkers = _outerMarkers(latLngs, route), $startViewMarker = outerMarkers.sv, $endViewMarker = outerMarkers.ev;
    let pointCount = latLngs.length, pointAddingMode = _appendMode, startPoint = outerMarkers.s, endPoint = outerMarkers.e;
    if (pointCount > 1) {
        _fillInRoute(latLngs, route);
    }
    const length = _routeLength(route);
    _updateRouteColors(route);
    return route;
}, _outerMarkers = (latLngs, route) => {
    const markerCount = latLngs.length, lastMarkerIndex = markerCount - 1, startLatLng = latLngs[0], endLatLng = latLngs[lastMarkerIndex], multiplePoints = (markerCount > 1), markerPaneId = route.p().mid(), svSettings = Object.assign(Object.assign({}, _markerSettings['sv']), { pane: markerPaneId }), evSettings = Object.assign(Object.assign({}, _markerSettings['ev']), { pane: markerPaneId }), $startViewMarker = new _ViewMarker(startLatLng, svSettings, route), $endViewMarker = new _ViewMarker(endLatLng, evSettings, route), startPoint = _routePoint(startLatLng, 's', route), endPoint = multiplePoints ?
        _routePoint(endLatLng, 'e', route) : startPoint;
    return {
        sv: $startViewMarker,
        ev: $endViewMarker,
        s: startPoint,
        e: endPoint,
    };
}, _fillInRoute = (latLngs, route) => {
    const pointCount = route.c(), lastPointIndex = pointCount - 1, lineCount = lastPointIndex, lastLineIndex = lineCount - 1, points = new Array(pointCount), lines = new Array(lineCount);
    points[0] = route.s();
    points[lastPointIndex] = route.e();
    for (let i = 0; i < lastLineIndex; ++i) {
        const nextLatLng = latLngs[i + 1], prevPoint = points[i], nextPoint = points[i + 1] = _routePoint(nextLatLng, 'c', route);
        lines[i] = _routeLine(route, prevPoint, nextPoint);
    }
    lines[lastLineIndex] = _routeLine(route, points[lastLineIndex], route.e());
    _connectPoints(points, lines, route);
}, _connectPoints = (points, lines, route) => {
    const lineCount = lines.length, lastLineIndex = lineCount - 1;
    route.s().set({
        ol: lines[0],
        np: points[1],
    });
    route.e().set({
        il: lines[lastLineIndex],
        pp: points[lastLineIndex],
    });
    for (let i = 1; i < lineCount; ++i) {
        points[i].set({
            pp: points[i - 1],
            il: lines[i - 1],
            ol: lines[i],
            np: points[i + 1],
        });
    }
}, _latLngs = (startPoint, endPoint) => {
    const latLngs = [];
    let currentPoint = startPoint;
    while (true) {
        if (!currentPoint) {
            break;
        }
        const currentLatLng = currentPoint.m().getLatLng();
        latLngs.push(currentLatLng);
        if (currentPoint === endPoint) {
            break;
        }
        const nextPoint = currentPoint.np();
        if (!nextPoint) {
            break;
        }
        currentPoint = nextPoint;
    }
    return latLngs;
}, _setToAppendMode = (route) => {
    route.set({ am: _appendMode });
}, _setToPrependMode = (route) => {
    route.set({ am: _prependMode });
}, _appendMode = 1, _prependMode = 2;
export { _route, _latLngs, _setToAppendMode, _setToPrependMode, _appendMode, _prependMode, };
